import { Observable } from "rxjs";
import * as NexusStream from "./stream";
import { Stream } from "./stream/Stream";
import environment from "@/config";

export class BaseMonitorWs {
  stream: Stream | null;
  constructor() {}

  disconnect() {
    this.stream = null;
    NexusStream.disconnect();
  }

  async listen(id: string, channel: string): Promise<Observable<any>> {
    if (environment.rtc.skip) {
      return new Observable((observer) => {});
    }

    if (!this.stream) {
      await this.connect();
    }

    return NexusStream.channel(channel);
  }

  async connect() {
    const host: string = environment.rtc.host;
    const transports = ["websocket"];
    const debug = false;
    this.stream = await NexusStream.connect({ host, transports, debug });
  }
}
